import type { intlFormatPropTypes } from "react-intl";
import { z } from "zod";

type BuildListingDetailsSchemaArgs = {
  intl: intlFormatPropTypes;
};

const buildListingDetailsFormSchema = ({
  intl,
}: BuildListingDetailsSchemaArgs) =>
  z.object({
    title: z
      .string()
      .trim()
      .min(
        1,
        intl.formatMessage({
          id: "hosting.listing_details.title_required",
          defaultMessage: "Please enter a title",
        }),
      ),
    description: z.string().optional(),
    amenities: z.record(z.boolean()),
    customAmenities: z.record(z.boolean()),
  });

type ListingDetailsFormValues = z.infer<
  ReturnType<typeof buildListingDetailsFormSchema>
>;

export { buildListingDetailsFormSchema };
export type { ListingDetailsFormValues };
